fourToldApp.factory("countryCode", function ($rootScope, $http, $q, APIKeyGooglePlaces) {
    var dialCode;
    var _dialCode = function (requestPermission, themeInfo) {
        var deferred = $q.defer();
        if (requestPermission) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    function (position) {
                        var lat = position.coords.latitude;
                        var lng = position.coords.longitude;
                        var location = {};
                        var url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=" + position.coords.latitude + "," + position.coords.longitude + "&key=" + APIKeyGooglePlaces + "&&sensor=true&callback=initMap";
                        $http({
                            url: url,
                            type: "GET",
                            cache: false,
                        }).then(function (data) {
                            location.longitude = position.coords.longitude;
                            location.latitude = position.coords.latitude;
                            $rootScope.location = data;
                            $rootScope.latLong = location;
                            //$scope.progressCircular = undefined;
                            if (data.data.results[0]) {
                                for (var i = 0; i < data.data.results[0].address_components.length; i++) {
                                    if (data.data.results[0].address_components[i].types[0] == "country") {
                                        location.country = data.data.results[0].address_components[i].short_name;
                                    }
                                }

                                switch (location.country) {
                                    case "CO":
                                        dialCode = "+57";
                                        break;
                                    case "US":
                                        dialCode = "+1";
                                        break;
                                    case "VE":
                                        dialCode = "+58";
                                        break;
                                    case "PE":
                                        dialCode = "+51";
                                        break;
                                    case "EC":
                                        dialCode = "+593";
                                    default:
                                        "+57";
                                        break;
                                }

                                if (themeInfo) {
                                    if (themeInfo.phone) {
                                        if (themeInfo.phone.defaultPhoneSuffix) {
                                            dialCode = themeInfo.phone.defaultPhoneSuffix;
                                        } else if (themeInfo.phone.countryCodes != null) {
                                            for (var i = 0; i < themeInfo.phone.countryCodes.length; i++) {
                                                var obj = themeInfo.phone.countryCodes[i];
                                                if (location.country === obj.country) {
                                                    dialCode = obj.code;
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            deferred.resolve(dialCode);
                        });
                    },
                    function (error) {
                        if (error.code == error.PERMISSION_DENIED) {
                            if (themeInfo != null && themeInfo.phone != null) {
                                if (themeInfo.phone.defaultPhoneSuffix != null) {
                                    dialCode = themeInfo.phone.defaultPhoneSuffix;
                                } else {
                                    if (themeInfo.phone.countryCodes != null && themeInfo.phone.countryCodes.length > 0) {
                                        var countryCode = themeInfo.phone.countryCodes[0];
                                        dialCode = countryCode.code;
                                    }
                                }

                                deferred.resolve(dialCode);
                            } else deferred.reject(error.code);
                        }
                    }
                );
            } else if (themeInfo != null && themeInfo.phone != null) {
                if (themeInfo.phone.defaultPhoneSuffix != null) {
                    dialCode = themeInfo.phone.defaultPhoneSuffix;
                } else {
                    if (themeInfo.phone.countryCodes != null && themeInfo.phone.countryCodes.length > 0) {
                        var countryCode = themeInfo.phone.countryCodes[0];
                        dialCode = countryCode.code;
                    }
                }

                deferred.resolve(dialCode);
            }
        } else if (themeInfo != null && themeInfo.phone != null) {
            if (themeInfo.phone.defaultPhoneSuffix != null) {
                dialCode = themeInfo.phone.defaultPhoneSuffix;
            } else {
                if (themeInfo.phone.countryCodes != null && themeInfo.phone.countryCodes.length > 0) {
                    var countryCode = themeInfo.phone.countryCodes[0];
                    dialCode = countryCode.code;
                }
            }

            deferred.resolve(dialCode);
        }

        return deferred.promise;
    };
    return {
        dialCode: _dialCode
    };
});

fourToldApp.factory("countries", function (theme) {
    var themeInfo = theme.getTheme();
    var data = {};
    if (themeInfo) {
        if (themeInfo.phone && themeInfo.phone.countryCodes) {
            data = {
                countries: [],
            };
            themeInfo.phone.countryCodes.map(function (item) {
                data.countries.push({
                    dial_code: item.code,
                    code: item.country,
                });
            });
        }
    }

    if (data.countries === null || data.countries === undefined) {
        data = {
            countries: [
                {
                    name: "Colombia",
                    dial_code: "+57",
                    code: "CO",
                },
                {
                    name: "United States",
                    dial_code: "+1",
                    code: "US",
                },
                {
                    name: "Venezuela, Bolivarian Republic of",
                    dial_code: "+58",
                    code: "VE",
                },
                {
                    name: "Perú",
                    dial_code: "+51",
                    code: "PE",
                },
                {
                    name: "Ecuador",
                    dial_code: "+593",
                    code: "EC",
                },
            ],
        };
    }
    return data;
});

fourToldApp.factory("docIdTypes", function (theme) {
    var themeInfo = theme.getTheme();
    var data = {};
    if (themeInfo) {        
        if (themeInfo.docId && themeInfo.docId.docIdTypes) {
            data = {
                docIdTypes: [],
            };
            themeInfo.docId.docIdTypes.map(function (item) {
                data.docIdTypes.push({
                    id: item.id,
                    description: item.description,
                });
            });
        }
    }

    if (data.docIdTypes === null || data.docIdTypes === undefined) {
        data = {
            docIdTypes: [ 
                {
                    "description": "DNI",
                    "id": 1,
                },
                {
                    "description": "Carnet de extranjería",
                    "id": 2,
                }
            ]
        };
    }
    return data;
});
fourToldApp.factory("countriesList", function () {
    var data;
    return{
      set: function(theme){
        data = {};
        if (theme) {
            if (theme.phone && theme.phone.countryCodes) {
                data = {
                    countries: [],
                };
                theme.phone.countryCodes.map(function (item) {
                    data.countries.push({
                        dial_code: item.code,
                        code: item.country,
                    });
                });
            }
        }
        if (data.countries === null || data.countries === undefined) {
            data = {
                countries: [
                    {
                        name: "Colombia",
                        dial_code: "+57",
                        code: "CO",
                    },
                    {
                        name: "United States",
                        dial_code: "+1",
                        code: "US",
                    },
                    {
                        name: "Venezuela, Bolivarian Republic of",
                        dial_code: "+58",
                        code: "VE",
                    },
                    {
                        name: "Perú",
                        dial_code: "+51",
                        code: "PE",
                    },
                    {
                        name: "Ecuador",
                        dial_code: "+593",
                        code: "EC",
                    },
                ],
            };
        }
      },
      get: function(){
        return data;      
      }
    }
});

